import { createQueryHook } from '~/shared/providers/api';

export interface RoleUserCountsResult {
  counts: Record<string, number>;
}

/**
 * Query hook for fetching unique user counts per role.
 * Fetches all user role assignments and counts unique users for each role.
 */
export const useRoleUserCountsQuery = createQueryHook(
  'settings.teamPermissions.roleUserCounts',
  () => ({
    coreUserRoleAssignments: {
      __args: {
        filter: {
          pagination: {
            limit: 10000,
            offset: 0,
          },
        },
      },
      entries: {
        userId: true,
        role: {
          id: true,
        },
      },
    },
  }),
  {
    select: (data): RoleUserCountsResult => {
      const entries = data?.coreUserRoleAssignments?.entries ?? [];

      const roleUserSets = new Map<string, Set<string>>();

      entries.forEach((assignment) => {
        const roleId = assignment.role?.id;
        const userId = assignment.userId;
        if (!roleId || !userId) return;

        if (!roleUserSets.has(roleId)) {
          roleUserSets.set(roleId, new Set());
        }
        roleUserSets.get(roleId)?.add(userId);
      });

      const counts: Record<string, number> = {};
      roleUserSets.forEach((users, roleId) => {
        counts[roleId] = users.size;
      });

      return { counts };
    },
  },
);
